import "antd/es/button/style";
import _Button from "antd/es/button";
var _excluded = ["type", "loading", "icon", "disabled", "flexCenter", "disabledReason", "style", "minWidth"];

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import { IconLoading3QuartersOutlined } from '@osui/icons';
import Tooltip from '@osui/tooltip';
import './index.less';
var clsPrefix = 'osui-button';

var PureIconButton = function PureIconButton(props) {
  var Icon = props.icon;
  var innerClassName = classNames("".concat(clsPrefix, "-btn-icon"), props.className);

  if (props.loading) {
    return /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.createElement(IconLoading3QuartersOutlined, {
      spin: true
    }), _objectSpread(_objectSpread({}, props), {}, {
      disabled: true,
      className: classNames(props.className, "".concat(clsPrefix, "-btn-icon ").concat(clsPrefix, "-icon-spinner ").concat(clsPrefix, "-keep-children"))
    }));
  }

  return /*#__PURE__*/React.cloneElement(Icon, _objectSpread(_objectSpread({}, props), {}, {
    className: innerClassName
  }));
};

var MIN_WIDTH = 72; // UE要求

var rxOneTwoThreeCNChar = /^[\u4e00-\u9fa5]{1,3}$/;
var isOneTwoThreeCNChar = rxOneTwoThreeCNChar.test.bind(rxOneTwoThreeCNChar);
/* eslint-disable complexity */

var InternalButton = function InternalButton(_ref, ref) {
  var _classNames;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      loading = _ref.loading,
      icon = _ref.icon,
      disabled = _ref.disabled,
      flexCenter = _ref.flexCenter,
      disabledReason = _ref.disabledReason,
      style = _ref.style,
      minWidth = _ref.minWidth,
      props = _objectWithoutProperties(_ref, _excluded);

  var innerIcon = icon;
  var loadingProp = _typeof(loading) === 'object' ? {
    loading: loading
  } : {};
  var isLoading = typeof loading === 'boolean' && loading;

  if (type === 'icon') {
    // icon作为button
    return /*#__PURE__*/React.createElement(PureIconButton, _objectSpread({
      loading: isLoading,
      icon: icon,
      disabled: disabled
    }, props));
  } // icon在作为children


  var shouldMinWidth = function shouldMinWidth() {
    if (typeof minWidth === 'boolean') {
      return minWidth;
    }

    if (type === 'link' || type === 'text') {
      return false;
    } // 只有icon时不设置minWidth


    if (icon && !props.children) {
      return false;
    }

    if (typeof props.children === 'string' && isOneTwoThreeCNChar(props.children)) {
      return true;
    }
  }; // 当loading且有icon的button时，icon替换成spinner，不论什么情况都要保持后面的chidlren


  if (isLoading && icon) {
    innerIcon = /*#__PURE__*/React.createElement(IconLoading3QuartersOutlined, {
      spin: true,
      className: "".concat(clsPrefix, "-icon-spinner ").concat(clsPrefix, "-keep-children")
    });
  } // 当loading但没有icon时，children替换成spinner，根据主题保留或者隐藏children。
  // osc的文字按钮loading时，文字替换成loading icon；而icloud主题则是保留icon和文字


  if (isLoading && !icon) {
    innerIcon = /*#__PURE__*/React.createElement(IconLoading3QuartersOutlined, {
      spin: true,
      className: "".concat(clsPrefix, "-icon-spinner")
    });
  }

  var success = props.success,
      error = props.error,
      danger = props.danger,
      warning = props.warning; // 如果minWidth为falsy时，不要minWidth属性

  var innerStyle = shouldMinWidth() && _objectSpread(_objectSpread({}, style), {}, {
    minWidth: typeof minWidth === 'boolean' ? MIN_WIDTH : minWidth || MIN_WIDTH
  }) || style;
  var PatchedButton = /*#__PURE__*/React.createElement(_Button, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    type: type,
    className: classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-loading"), isLoading), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), isLoading || disabled), _defineProperty(_classNames, "".concat(clsPrefix, "-face-success"), success), _defineProperty(_classNames, "".concat(clsPrefix, "-face-error"), error || danger), _defineProperty(_classNames, "".concat(clsPrefix, "-face-warning"), warning), _defineProperty(_classNames, "".concat(clsPrefix, "-flex-center"), flexCenter || isLoading), _classNames), props.className),
    icon: innerIcon,
    disabled: isLoading || disabled,
    style: innerStyle
  }, loadingProp));

  if (disabledReason && disabled) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      placement: "top",
      title: disabledReason
    }, PatchedButton);
  }

  return PatchedButton;
};

var Button = /*#__PURE__*/React.forwardRef(InternalButton);
Button.Group = _Button.Group; // eslint-disable-next-line no-underscore-dangle

Button.__ANT_BUTTON = true; // 用于tooltip disable时确保hover生效： https://github.com/ant-design/ant-design/pull/4865/files#diff-186839a30bf8b9d67a4b10bf7c091d5fR88

export default Button;
//# sourceMappingURL=index.js.map